import React from "react";
import Layout from "./Layout";
import ListSportsSection from "../sections/ListSportsSection";

const ListSports = () => {
  return (
    <>
      <Layout>
        <ListSportsSection />
      </Layout>
    </>
  );
};

export default ListSports;
